module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8CYIm"))).then(() => parcelRequire('dJXJK'));